import config from '@/config'
import lang from '@/lang'
import { purchaseStates } from '@/modules/base/util/constants'

const {
  OPEN,
  ORDERED,
  DELIVERED,
} = purchaseStates

const urls = {
  single: 'purchase',
  multiple: 'purchases',
}

const resourceUrl = `${config.resourceHost}purchase`

export default {
  resourceUrl,
  purchaseListSetting: `${config.resourceHost}setting/userlist/purchase`,
  getNewPurchase: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: {
        state: {
          type: 'set',
          values: [],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        state: {
          type: 'set',
          values: [OPEN],
        },
      },
    },
    {
      name: 'ordered',
      title: lang.purchaseNotDelivered,
      quickFilter: {
        state: {
          type: 'set',
          values: [ORDERED],
        },
      },
    },
    {
      name: 'delivered',
      title: lang.fullyDelivered,
      quickFilter: {
        state: {
          type: 'set',
          values: [DELIVERED],
        },
      },
    },
  ],
}
